<template>
  <div class="choose-sch">
    <Modal v-model="show" title="选择学校" :width="modalWidth">
      <MultipleFtowTable
        ref="multipleTableRef"
        :right-title="`选中学校`"
        :right-text="`请先选择学校`"
        :table-data="classList"
        :table-columns="classListColumn"
        :select-data="selectclassList"
        :table-loading="loading"
      >
        <div slot="left-header">
          <Form ref="formInline" inline>
            <FormItem>
              <Input
                v-model="searchForm.searchStr"
                type="text"
                style="width: 180px"
                placeholder="请输入机构名称"
                clearable
              >
              </Input>
            </FormItem>
            <FormItem>
              <Cascader
                v-model="areaArr"
                placeholder="请输入选择区域"
                :data="regionDataList"
                style="width:250px;"
                @on-change="areaChange"
              ></Cascader>
            </FormItem>
            <Button type="primary" @click="handleSearch">搜索</Button>
          </Form>
        </div>
        <div slot="left-footer">
          <div class="paging">
            <Page
              :current="pageInfo.pageNum"
              :total="pageInfo.total"
              :page-size="pageInfo.pageSize"
              show-total
              show-elevator
              show-sizer
              :page-size-opts="pageSizeOpts"
              @on-change="handlepageChange"
              @on-page-size-change="handlePageSize"
            ></Page>
          </div>
        </div>
      </MultipleFtowTable>
      <div slot="footer">
        <Button @click="handleCancel">取消</Button>
        <Button type="primary" @click="handleOk">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import educationAdmin from '@/request/educationAdmin/index.js';
import { courseTypeData } from '@pv/eduCenter/common/assets/data/data';
import MultipleFtowTable from '@c/Base/MultipleFtowTable.vue';
import { regionDataList } from '@/utils/dictionary';
export default {
  components: {
    MultipleFtowTable
  },
  props: {
    modalWidth: {
      type: [Number, String],
      default: 70
    }
  },
  data() {
    return {
      areaArr: [],
      regionDataList: [],
      areaId: '',
      pageSizeOpts: [10, 20, 50, 100],
      show: false,

      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      searchForm: {
        searchStr: ''
      },
      classTypeData: [-1], // 课程分类-默认全部
      portOrg: localStorage.getItem('portOrg'),
      classListColumn: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '学校名称',
          key: 'name',
          minWidth: 200
        },
        {
          title: '所属地区',
          key: 'areaName',
          minWidth: 200
        }
      ],
      classList: [], // 表格班级列表
      selectclassList: [], // 选中的班级列表
      loading: false,
      courseList: [
        {
          value: -1,
          label: '全部'
        },
        {
          value: 1,
          label: '素质课程'
        },
        {
          value: 2,
          label: '托管'
        }
      ],
      orgId: '', // 学校id
      termId: '', // 年度学期
      courseTypeListData: [...courseTypeData], // 课程分类列表
      selectedIdList: []
    };
  },
  created() {
    this.regionDataList = [...regionDataList];
  },
  methods: {
    areaChange(value, selectedData) {
      this.areaId = value[value.length - 1];
      // this.formValidate.area = '';
      // selectedData.forEach((item, index) => {
      //   if (index == 0) {
      //     this.formValidate.area += `${item.label}`;
      //   } else {
      //     this.formValidate.area += `/${item.label}`;
      //   }
      // });
      // console.log(value, selectedData, value[value.length - 1]);
    },
    handleOpen(data, selectedIdList) {
      this.show = true;
      this.classList = [];
      this.pageInfo.pageNum = 1;
      this.selectclassList = data;
      this.selectedIdList = selectedIdList;
      this.getclassListData();
    },
    handleClosure() {
      this.show = false;
    },
    handleCancel() {
      this.show = false;
    },
    handleOk() {
      this.$emit('on-finish', this.$refs.multipleTableRef.getResult());
    },
    // 页码改变
    handlepageChange(page) {
      this.pageInfo.pageNum = page;
      this.getclassListData();
    },
    // 页条数改变
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum = 1;
      this.getclassListData();
    },
    // 获取班级列表数据
    async getclassListData() {
      // this.searchForm,
      const params = Object.assign({}, this.searchForm, {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      });
      if (this.areaId) {
        params.areaCode = this.areaId;
      }
      this.loading = true;
      const res = await educationAdmin.getEduRelBasicSchoolApi(params);
      this.loading = false;
      console.log('res', res);
      if (res.status === 200) {
        this.classList = res.message.list.map((item) => {
          item.stunumber = item.studentCnt;
          item._disabled = this.selectedIdList.includes(item.orgId);
          return item;
        });
        this.classList = res.message.list;
        this.pageInfo.total = Number(res.message.total);
      }
    },
    // 点击搜索
    handleSearch() {
      this.getclassListData();
    },
    // 自定义级联显示内容
    format(labels, selectedData) {
      return labels.join('-');
    },
    // 课程分类级联选择
    handleCourseType(value) {
      switch (value.length) {
        case 0:
          this.searchForm.classType = null;
          this.searchForm.courseTypeKind = null;
          break;
        case 1:
          this.searchForm.classType = value[0] == -1 ? null : value[0];
          this.searchForm.courseTypeKind = null;
          break;
        case 2:
          this.searchForm.classType = value[0];
          this.searchForm.courseTypeKind = value[1];
          break;
        default:
          break;
      }
    },
    // 获取课程分类
    getCourseTypeName(id, childid) {
      const name = this.courseTypeListData
        .find((item) => item.value === id)
        .children.find((item) => item.value === childid);
      const courseTypeName = name ? name.__label.replace('/', '-') : '';
      return courseTypeName;
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  .left {
    width: calc(100% - 400px);
    margin-right: 16px;
  }
  .right {
    width: 400px;
    .select-list-wrap {
      max-height: 500px;
      overflow-y: scroll;
      padding: 10px 10px 0;
      border-radius: 4px;
      background-color: #eee;
      li {
        display: flex;
        justify-content: space-between;
        margin-bottom: 6px;
        font-size: 14px;
      }
    }
  }
}
</style>
